import React from 'react'
import { createComponent } from '@ycos/fela'
import { getFontStyles } from '@ycos/primitives'

const sharedStyles = ({ theme }) => ({
  ...getFontStyles(theme.typography, { type: 'Label', name: '7' }),
  margin: 'auto',
  textAlign: 'center',
  color: theme.typography.colors.PrimaryWhite,
  textTransform: 'uppercase'
})

const LoyaltyHeadingPreTitle = createComponent('LoyaltyHeadingPreTitle', ({ theme }) => {
  const { spacingMultiplier, custom } = theme;
  return {
    ...sharedStyles({ theme }),
    fontFamily: theme.custom.eipHero.preTitle.fontFamily,
    fontSize: theme.custom.eipHero.preTitle.fontSizeSmall,
    lineHeight: custom.eipHero.preTitle.lineHeightSmall,
    paddingTop: '300px',
    paddingBottom: `${spacingMultiplier / 2}px`,
    'screen-medium': {
      fontSize: custom.eipHero.preTitle.fontSizeMedium,
      lineHeight: custom.eipHero.preTitle.lineHeightMedium
    }
  }
})

const LoyaltyHeadingTitle = createComponent('LoyaltyHeadingTitle', ({ theme }) => ({
  ...sharedStyles({ theme }),
  fontFamily: theme.custom.eipHero.title.fontFamily,
  fontSize: theme.custom.eipHero.title.fontSizeSmall,
  lineHeight: theme.custom.eipHero.title.lineHeightSmall,
  width: theme.custom.eipHero.title.widthSmall,
  paddingBottom: `${theme.spacingMultiplier}px`,
  'screen-medium': {
    fontSize: theme.custom.eipHero.title.fontSizeMedium,
    lineHeight: theme.custom.eipHero.title.lineHeightMedium,
    width: theme.custom.eipHero.title.widthMedium,
    paddingBottom: `${2 * theme.spacingMultiplier}px`
  }
}))

const LoyaltyHeadingText = createComponent('LoyaltyHeadingText', ({ theme }) => {
  const { type, name } = theme.custom.eipHero.textStyles
  return {
    ...getFontStyles(theme.typography, { type, name }),
    color: theme.typography.colors.PrimaryWhite,
    textAlign: 'center',
    width: '311px',
    margin: 'auto',
    lineHeight: '22px',
    'screen-medium': {
      lineHeight: '18px',
      width: '461px'
    },
    'screen-large': {
      lineHeight: '22px',
      width: '632px'
    },
    'screen-xlarge': {
      lineHeight: '30px',
      width: '909px'
    }
  }
})

export const LoyaltyHeadingComponent = ({ teaserTitle, preTitle, teaserText, theme }) => {
  return (
    <div>
      <LoyaltyHeadingPreTitle theme={theme}>{preTitle}</LoyaltyHeadingPreTitle>
      <LoyaltyHeadingTitle theme={theme}>{teaserTitle}</LoyaltyHeadingTitle>
      <LoyaltyHeadingText theme={theme}>{teaserText}</LoyaltyHeadingText>
    </div>
  )
}
